import React from 'react'

import { useAPIGetPerencanaanRHKOptions } from 'api/kinerja/penilik-pegawai/perencanaan'

import type {
  PraktikKinerjaItem,
  RHKOptionType,
} from 'types/kinerja-penilik-pegawai'

type TUsePraktikKinerjaHooks = {
  praktikKinerjaData: PraktikKinerjaItem[]
}
export const usePraktikKinerja = (): TUsePraktikKinerjaHooks => {
  const {
    data: perencanaanPraktikKinerjaResponse,
    isSuccess: isPerencanaanPraktikKinerjaSuccess,
  } = useAPIGetPerencanaanRHKOptions({
    type: 'praktik_kinerja' as RHKOptionType,
  })

  const praktikKinerjaData = React.useMemo(() => {
    if (isPerencanaanPraktikKinerjaSuccess) {
      return perencanaanPraktikKinerjaResponse?.data ?? []
    }

    return []
  }, [
    isPerencanaanPraktikKinerjaSuccess,
    perencanaanPraktikKinerjaResponse?.data,
  ])

  return {
    praktikKinerjaData,
  }
}
